var simplemaps_usmap_mapdata={
  main_settings: {
   //General settings
    width: "responsive", //'700' or 'responsive'
    background_color: "#FFFFFF",
    background_transparent: "yes",
    border_color: "#ffffff",
    popups: "detect",
    order_number: 'FLA260427-1468-42105',
    
    //State defaults
    state_description: "State Description",
    state_color: "#cacaca",
    state_hover_color: "#cacaca",
    state_url: "",
    border_size: 1.5,
    all_states_inactive: "no",
    all_states_zoomable: "yes",
    
    //Location defaults
    location_description: "Add location markers using latitude and longitude!",
    location_color: "#a0281e",
    location_opacity: 0.8,
    location_hover_opacity: 1,
    location_url: "",
    location_size: 25,
    location_type: "square",
    location_image_source: "frog.png",
    location_border_color: "#FFFFFF",
    location_border: 2,
    location_hover_border: 2.5,
    all_locations_inactive: "no",
    all_locations_hidden: "no",
    
    //Label defaults
    label_color: "#fff",
    label_hover_color: "#fff",
    label_size: 22,
    label_font: "Arial",
    hide_labels: "no",
    hide_eastern_labels: "no",
    manual_zoom: "no",
    back_image: "no",
    initial_back: "no",
    initial_zoom: -1,
    initial_zoom_solo: "no",
    region_opacity: 1,
    region_hover_opacity: 0.6,
    zoom_out_incrementally: "yes",
    zoom_percentage: 0.99,
    zoom_time: 0.5,
    
    //Popup settings
    popup_color: "white",
    popup_opacity: 0.9,
    popup_shadow: 1,
    popup_corners: 5,
    popup_font: "12px/1.5 Verdana, Arial, Helvetica, sans-serif",
    popup_nocss: "no",
    
    //Advanced settings
    div: "dealersUSA",
    auto_load: "yes",
    url_new_tab: "yes",
    images_directory: "/static/lib/simplemaps/map_images/",
    fade_time: 0.1,
    import_labels: "no",
    link_text: "View Website",
    state_image_url: "",
    state_image_position: "",
    location_image_url: ""
  },
  state_specific: {
    HI: {
      name: "Hawaii"
    },
    AK: {
      name: "Alaska"
    },
    FL: {
      name: "Florida"
    },
    NH: {
      name: "New Hampshire"
    },
    VT: {
      name: "Vermont"
    },
    ME: {
      name: "Maine"
    },
    RI: {
      name: "Rhode Island"
    },
    NY: {
      name: "New York"
    },
    PA: {
      name: "Pennsylvania"
    },
    NJ: {
      name: "New Jersey"
    },
    DE: {
      name: "Delaware"
    },
    MD: {
      name: "Maryland"
    },
    VA: {
      name: "Virginia"
    },
    WV: {
      name: "West Virginia"
    },
    OH: {
      name: "Ohio"
    },
    IN: {
      name: "Indiana"
    },
    IL: {
      name: "Illinois"
    },
    CT: {
      name: "Connecticut"
    },
    WI: {
      name: "Wisconsin"
    },
    NC: {
      name: "North Carolina"
    },
    DC: {
      name: "District of Columbia"
    },
    MA: {
      name: "Massachusetts"
    },
    TN: {
      name: "Tennessee"
    },
    AR: {
      name: "Arkansas"
    },
    MO: {
      name: "Missouri"
    },
    GA: {
      name: "Georgia"
    },
    SC: {
      name: "South Carolina"
    },
    KY: {
      name: "Kentucky"
    },
    AL: {
      name: "Alabama"
    },
    LA: {
      name: "Louisiana"
    },
    MS: {
      name: "Mississippi"
    },
    IA: {
      name: "Iowa"
    },
    MN: {
      name: "Minnesota"
    },
    OK: {
      name: "Oklahoma"
    },
    TX: {
      name: "Texas"
    },
    NM: {
      name: "New Mexico"
    },
    KS: {
      name: "Kansas"
    },
    NE: {
      name: "Nebraska"
    },
    SD: {
      name: "South Dakota"
    },
    ND: {
      name: "North Dakota"
    },
    WY: {
      name: "Wyoming"
    },
    MT: {
      name: "Montana"
    },
    CO: {
      name: "Colorado"
    },
    UT: {
      name: "Utah"
    },
    AZ: {
      name: "Arizona"
    },
    NV: {
      name: "Nevada"
    },
    OR: {
      name: "Oregon"
    },
    WA: {
      name: "Washington"
    },
    CA: {
      name: "California"
    },
    MI: {
      name: "Michigan"
    },
    ID: {
      name: "Idaho"
    },
    GU: {
      name: "Guam",
      hide: "yes"
    },
    VI: {
      name: "Virgin Islands",
      hide: "yes"
    },
    PR: {
      name: "Puerto Rico",
      hide: "yes"
    },
    MP: {
      name: "Northern Mariana Islands",
      hide: "yes"
    },
    AS: {
      name: "American Samoa",
      hide: "yes"
    }
  },
  locations: {
    "0": {
      name: "Atlantic Coast Fire Trucks",
      lat: "35.5439441",
      lng: "-81.0420206",
      description: "5867 Balsom Ridge  Denver NC 28037 (704) 966-1898 acfiretrucks.com"
    },
    "1": {
      name: "Atlantic Emergency Solutions",
      lat: "38.7923",
      lng: "-77.562455",
      description: "12351 Randolph Ridge Lane  Manassas VA 20109 (703) 393-9911 atlanticemergency.com"
    },
    "2": {
      lat: "36.0902699",
      lng: "-80.00011",
      name: "Atlantic Emergency Solutions",
      description: "8421 Norcross Road  Colfax NC 27235 (336) 996-2771 atlanticemergency.com"
    },
    "3": {
      lat: "38.037018",
      lng: "-78.491926",
      name: "Atlantic Emergency Solutions",
      description: "925 West Street  Charlottesville VA 22903 (434) 202-1470 atlanticemergency.com"
    },
    "4": {
      lat: "39.1619966",
      lng: "-76.7037806",
      name: "Atlantic Emergency Solutions",
      description: "7462 Candlewood Rd, Suite E  Hanover MD 21076 (410) 609-2306 atlanticemergency.com"
    },
    "5": {
      lat: "39.435603",
      lng: "-75.75173",
      name: "Atlantic Emergency Solutions",
      description: "121 Patriot Drive  Middletown DE 19709-8761 (302) 449-3473 atlanticemergency.com"
    },
    "6": {
      lat: "37.1771699",
      lng: "-76.473105",
      name: "Atlantic Emergency Solutions",
      description: "144 Freedom Blvd.  Yorktown VA 23692 (757) 369-0911 atlanticemergency.com"
    },
    "7": {
      lat: "37.349438",
      lng: "-77.39964",
      name: "Atlantic Emergency Solutions",
      description: "13051 Redwater Drive  Chester VA 23836 (804) 751-0911 atlanticemergency.com"
    },
    "8": {
      lat: "37.267553",
      lng: "-79.900203",
      name: "Atlantic Emergency Solutions",
      description: "845 3rd Street  Vinton VA 24179 (540) 343-3323 atlanticemergency.com"
    },
    "9": {
      lat: "38.833128",
      lng: "-90.0482434",
      name: "Banner Fire Equipment, inc.",
      description: "4601 Hedge Road  Roxana IL 62084 (618) 251 4200 bannerfire.com"
    },
    "10": {
      lat: "37.379877",
      lng: "-79.7147789",
      name: "Blue Ridge Rescue Supplies",
      description: "1273 Colonial Fort Drive  Montvale VA 24122 (866) 411 9745 brrs.net"
    },
    "11": {
      lat: "30.231375",
      lng: "-92.304425",
      name: "Bonaventure Fire & Safety",
      description: "162 Industrial Drive  Rayne LA 70578 (800) 650-4900 bonafire.com"
    },
    "12": {
      lat: "42.236188",
      lng: "-71.563065",
      name: "Bulldog Fire and Emergency Apparatus",
      description: "17 Winter St  Woodville MA 1784 (508) 435-4054 bulldogfireapparatus.com"
    },
    "13": {
      lat: "35.980365",
      lng: "-77.850764",
      name: "C.W. Williams Fire Equipment Specialists ",
      description: "574 English Road  Rocky Mount NC 27804 (800) 277-3473 cwwilliamsfire.com"
    },
    "14": {
      lat: "40.3633536",
      lng: "-74.4654181",
      name: "Campbell Supply Company LLC.",
      description: "1015 Cranbury South River Road   South Brunswick NJ 8831 (732) 287-8884 campbellsupply.com"
    },
    "15": {
      lat: "38.399264",
      lng: "-78.898166",
      name: "CRS Upfitting",
      description: "615 Pleasent Valley Road  Harrisonburg VA 22801 (540) 438-8972 commonwealthsar.com"
    },
    "16": {
      lat: "32.718993",
      lng: "-102.648768",
      name: "Diamond Rescue Supplies",
      description: "545 US Hwy 180 W  Seminole TX 79360 (915) 234-7262 diamondrescuesupplies.com"
    },
    "17": {
      lat: "42.757369",
      lng: "-78.862194",
      name: "E-One Inc. Hamburg",
      description: "S-4760 Camp Road  Hamburg NY 14075 (716) 646 6780 eoneny.com"
    },
    "18": {
      lat: "42.0594573",
      lng: "-94.8431879",
      name: "Ed M. Feld Equipment",
      description: "113 Griffith Rd  Carroll IA 51401 (712) 792-3143 feldfire.com"
    },
    "19": {
      lat: "40.215262",
      lng: "-75.23635",
      name: "ESI Equipment, Inc",
      description: "119 Keystone Drive  Mountgomeryville PA 18936 (267) 803-1440 esiequipmentglobal.com"
    },
    "20": {
      lat: "39.1948306",
      lng: "-76.7486998",
      name: "FESCO Emergency Sales",
      description: "7010 Troy Hill Drive  Elkridge MD 21075 (410) 379-5353 fescosales.com"
    },
    "21": {
      lat: "35.997994",
      lng: "-77.77762",
      name: "Fire Connections",
      description: "2520 N Wesleyan Blvd  Rocky Mount NC 27804 (877) 358 3473 fireconnections.com"
    },
    "22": {
      lat: "40.1134569",
      lng: "-76.0532014",
      name: "Fire Line Equipment",
      description: "307 Twin Springs Court  New Holland PA 17557 (717) 354 8106 firelineequipment.com"
    },
    "23": {
      lat: "41.446176",
      lng: "-87.463879",
      name: "Fire Services Inc",
      description: "9545 Industrial Drive North  St. John IN 46373 (219) 365 7157 fireserviceinc.com"
    },
    "24": {
      lat: "33.966281",
      lng: "-83.780184",
      name: "Fireline, inc",
      description: "725 Patrick Industrial Lane  Winder GA 30680 (770) 868-4448 firelineinc.com"
    },
    "25": {
      lat: "40.1130536",
      lng: "-104.9718795",
      name: "Front Range Fire Apparatus",
      description: "7600 Miller Court  Longmont CO 80504 (303) 449-9911 frontrangefire.com"
    },
    "26": {
      lat: "32.9019185",
      lng: "-96.5759715",
      name: "Hall-Mark Texas (South)",
      description: "2805 Singleton  Rowlett TX 75088 (800) 922-4142 yelp.combizhall-mark-fire-apparatus-texas-houston"
    },
    "27": {
      lat: "40.861167",
      lng: "-75.8232281",
      name: "KME Kovatch",
      description: "1 Industrial Complex  Nesquehoning PA 18240 570-669-9461 www.kovach.com"
    },
    "28": {
      lat: "40.8611727",
      lng: "-75.8233409",
      name: "Kovatch Ford ",
      description: "1 Industrial Complex  Nesquehoning PA 18240 (570) 669-5111 kovatchford.com"
    },
    "29": {
      lat: "29.2223552",
      lng: "-82.1678245",
      name: "Matheny Fire and Emergency",
      description: "3431 NW 27TH AVE  Ocala FL 34475 (800) 524-6072 mathenymotors.com"
    },
    "30": {
      lat: "39.3726339",
      lng: "-104.8733281",
      name: "MAX FIRE",
      description: "1050 Topeka Way  Castle Rock CO 80109 (303) 814-8746 maxfire.com"
    },
    "31": {
      lat: "44.5910303",
      lng: "-83.3817988",
      name: "Michigan Rescue Technology; Factory Representative",
      description: "608 W. F30  Mikado MI 48745 989.736.1140 michiganrescuetechnology.comcontact.cfm"
    },
    "32": {
      lat: "34.6037555",
      lng: "-87.0088799",
      name: "Nafeco",
      description: "1519 Moulton St W  Decatur AL 35601 (256) 309-5655 nafeco.com"
    },
    "33": {
      lat: "36.0220595",
      lng: "-79.3617388",
      name: "Newtons Fire and Safety Equiptment",
      description: "2724 Darrell Newton Drive  Swepsonville NC 27359 (800) 672 5918 newtonsfire.com"
    },
    "34": {
      lat: "38.9642121",
      lng: "-76.1936994",
      name: "Patriot Fire LLC. ",
      description: "225 Hess Rd  Grasonville MD 21638 (410) 476-3152 patriotfireusa.com"
    },
    "35": {
      lat: "42.110004",
      lng: "-83.163038",
      name: "Payette Sales and Service",
      description: "27250 Kitty Hawk  Grosse ile MI 48138 (734) 676-2451 "
    },
    "36": {
      lat: "37.3712748",
      lng: "-79.2156057",
      name: "Piedmont Fleet Services",
      description: "201 Mill Ridge Rd  Lynchburg VA 24502 (434) 239-1748 piedmontfs.com"
    },
    "37": {
      lat: "44.2424214",
      lng: "-88.469351",
      name: "Pierce Manufacturing",
      description: "2600 American Drive  Appleton WI 54912 920-830-3000 www.piercemfg.com"
    },
    "38": {
      lat: "40.815834",
      lng: "-72.967634",
      name: "Proliner Rescue Vehicle Sales and Service",
      description: "18 Peconic Avenue  Medford NY 11763 (631) 447-9558 www.prolinerrescue.com"
    },
    "39": {
      lat: "40.7675199",
      lng: "-73.08084",
      name: "Rescue Vehicles, Inc.",
      description: "37 Jules Court  Bohemia NY 11716 (631) 567-2704 rescuevehicles.com"
    },
    "40": {
      lat: "34.8147348",
      lng: "-82.5186944",
      name: "Safe Industries",
      description: "5031 Hwy. 153  Easley SC 29642 (864) 845-7175 safeindustries.com"
    },
    "41": {
      lat: "34.9108229",
      lng: "-81.9657975",
      name: "Spartan Fire & Emergency Apparatus",
      description: "319 South Port Road  Roebuck SC 29376 (866) 582 2376 spartanfire.com"
    },
    "42": {
      lat: "30.4606199",
      lng: "-87.8845324",
      name: "Sunbelt Fire",
      description: "8050 McGowin Drive  Fairhope AL 36532 800-642-8484 sunbeltfire.com"
    },
    "43": {
      lat: "45.0260559",
      lng: "-83.4803021",
      name: "T&K Emergency lighting",
      description: "3370 Piper Rd  Alpena MI 49707 (989)-255-3972 tkfire.com"
    },
    "44": {
      lat: "44.4933757",
      lng: "-84.6623452",
      name: "Time Emergency",
      description: "2415 W Sunset Dr  Roscommon MI 48653 1-800-423-6628 timeemergency.com"
    },
    "45": {
      lat: "47.2940803",
      lng: "-122.2468151",
      name: "Vision X USA",
      description: "1601 Boundary Blvd  Auburn WA 98001 703-662-3458 www.hivizleds.com"
    },
    "46": {
      lat: "39.0510663",
      lng: "-84.6329069",
      name: "Vogelpohl Fire Equipment",
      description: "2770 Circleport Dr  Erlanger KY 41018 (859) 282-1000 vogelpohlfire.com"
    },
    "47": {
      lat: "40.8398181",
      lng: "-81.765725",
      name: "Will-Burt",
      description: "169 S. Main St  Orrville OH 44667 330-682-7015 willburt.com"
    },
    "48": {
      lat: "27.4296835",
      lng: "-82.5265904",
      name: "1 Stop LEDs & Safety, LLC",
      description: "6223 29th Street East  Bradenton FL 34203 (941) 404-8943 1stopledsafety.com"
    },
    "49": {
      lat: "41.0236568",
      lng: "-74.2974232",
      name: "10-75 EMERGENCY VEHICLES",
      description: "14 1st Ave #3  Haskell NJ 7420 (877) 614-7187 1075vehicles.com"
    },
    "50": {
      lat: "40.105282",
      lng: "-76.077393",
      name: "10-8 Emergency Vehicles",
      description: "501B E Main St  New Holland PA 17557 (717) 354-9221 10-8evs.net"
    },
    "51": {
      lat: "40.544051",
      lng: "-80.2124365",
      name: "1st Out Specialty Vehicles & Equipment",
      description: "1155 Stoops Ferry Rd.  Moon Township PA 15108 412-507-3000 1stoutspecialty.com"
    },
    "52": {
      lat: "42.6814572",
      lng: "-72.5402395",
      name: "413 Upfitting LLC",
      description: "162A Bald Mountain Rd  Bernardston MA 1337 413-668-5715 413upfitting.com"
    },
    "53": {
      lat: "46.4774631",
      lng: "-93.9777621",
      name: "803 4th Street",
      description: "  Ironton MN 56455 218-545-2277 autosmithmn.com"
    },
    "54": {
      lat: "38.9760317",
      lng: "-84.663992",
      name: "911 Fleet & Fire Equipment",
      description: "11 Lendale Drive  Florence KY 41042 (877) 605-2378 911fleet.com"
    },
    "55": {
      lat: "33.8577245",
      lng: "-117.7932576",
      name: "911 Vehicle",
      description: "5604 E La Palma Ave  Anaheim CA 92807 (714) 808-0911 911vehicle.com"
    },
    "56": {
      lat: "39.7624398",
      lng: "-89.6255692",
      name: "A.E.C. Fire & Safety",
      description: "3003 Stanton Ave.  Springfield IL 62703 217-529-3003 www.aecfire.com"
    },
    "57": {
      lat: "40.5603663",
      lng: "-74.4244645",
      name: "Absolute Fire Protection",
      description: "2800 Hamilton Blvd  South Plainfield NJ 7080 (908) 757-3600 absolutefire.com"
    },
    "58": {
      lat: "33.617481",
      lng: "-111.9000594",
      name: "Accessory Partners LLC",
      description: "8350 E. Evans Road Ste D1  Scottsdale AZ 85260 (866) 409-8673 accessorypartners.com"
    },
    "59": {
      lat: "42.9390562",
      lng: "-71.4675044",
      name: "Adirondack Emergency Vehicle Group",
      description: "264 S. River Rd Ste 436 Bedford NH 3110 (888) 494-2372 adkevg.com"
    },
    "60": {
      lat: "39.5661209",
      lng: "-77.6341212",
      name: "Adkins Automotive",
      description: "21036 National Pike  Boonsboro MD 21713 (240) 347-4383 adkinsauto.com"
    },
    "61": {
      lat: "21.4058845",
      lng: "-158.0043961",
      name: "Advanced Towing & Recovery",
      description: "94-210 Umeke Pl.  Waipahu HI 96797 808-456-8697 "
    },
    "62": {
      lat: "40.4286546",
      lng: "-81.3609109",
      name: "Advantech Service and Parts",
      description: "5609 Gundy Dr  Midvale OH 44653 (740) 922-2727 advantech911.com"
    },
    "63": {
      lat: "39.7624804",
      lng: "-89.6256795",
      name: "AEC Fire Safety",
      description: "3003 Stanton St  Springfield IL 62703 (217) 529-3003 aecfire.com"
    },
    "64": {
      lat: "38.418287",
      lng: "-82.231046",
      name: "All American Fire",
      description: "3253 Route 60 East  Ona WV 25545 (304) 733 3581 allamericanfire.us"
    },
    "65": {
      lat: "40.7808224",
      lng: "-81.4214167",
      name: "All American Fire",
      description: "3926 Southway Street SW  Canton OH 44706 (330) 479 1383 allamericanfire.us"
    },
    "66": {
      lat: "39.5157271",
      lng: "-83.5253857",
      name: "All American Fire",
      description: "5101 US Highway 22 SW  Washington OH 43160 (740) 333 6801 allamericanfire.us"
    },
    "67": {
      lat: "40.4803213",
      lng: "-78.7342687",
      name: "All American Fire and Safety",
      description: "155 Lovell Ave.  Ebensburg PA 15931 (814) 472-8650 allamericanfire.us"
    },
    "68": {
      lat: "35.8162279",
      lng: "-80.9841275",
      name: "All Pro Fire & Safety",
      description: "124 Tarlton Rd  Statesville NC 28625 (828) 302-9283 allprofire.com"
    },
    "69": {
      lat: "43.1542801",
      lng: "-86.1752899",
      name: "Allied Fire Sales & Service",
      description: "2770 E. Sternberg Rd Suite 1 Fruitport MI 49415 (616) 318-6443 alliedfiresales.com"
    },
    "70": {
      lat: "33.2643524",
      lng: "-93.8869697",
      name: "American Specialty Vehicles",
      description: "105 W Redcut Road  Fouke AR 71837 (844) 394-7373 americanspecialtyvehicles.com"
    },
    "71": {
      lat: "38.7159118",
      lng: "-120.864001",
      name: "Ample Supply, Inc.",
      description: "2325 Fieldstone Dr.  Placerville CA 95667 (916) 403-7898 amplesupplyinc.com"
    },
    "72": {
      lat: "35.864963",
      lng: "-81.3206444",
      name: "Anchor-Rtchey",
      description: "241 Advent Church Road  Taylorsville NC 28681  "
    },
    "73": {
      lat: "40.7447457",
      lng: "-111.9102831",
      name: "Apparatus Equipment and Service",
      description: "1103 South 700 West  Salt Lake City UT 84104 (801) 886-0600 apparatus-es.com"
    },
    "74": {
      lat: "38.2147443",
      lng: "-77.9053182",
      name: "Apparatus Solutions Emergency Vehicle Outfitter",
      description: "  Unionville VA 22567 (703) 946 7667 facebook.comApparatusSolutions"
    },
    "75": {
      lat: "38.498206",
      lng: "-77.9138662",
      name: "Apparatus Solutions Emergency Vehicle Outfitter",
      description: "15251 Rosson Troilo Circle  Brandy Station VA 22567-3058 (703) 946-7667 facebook.comApparatusSolutions"
    },
    "76": {
      lat: "40.0540337",
      lng: "-75.8761114",
      name: "ARNOLD FIRE EQUIPMENT",
      description: "253 Hill Rd  Honey Brook PA 19344 (610) 273-7073 arnoldfireequipment.com"
    },
    "77": {
      lat: "32.8306232",
      lng: "-104.3971277",
      name: "Artesia Fire Equipment",
      description: "1014 S 1st St  Artesia NM 88210 (575) 746-2426 artesiafire.com"
    },
    "78": {
      lat: "38.9566294",
      lng: "-92.2769751",
      name: "ARV",
      description: "521 Hillsdale Rd  Columbia MO 65201 573-443-8881 arvambulance.com"
    },
    "79": {
      lat: "40.2404963",
      lng: "-80.0727375",
      name: "Ashley Truck Service",
      description: "1335 Venetia Rd  Venetia PA 15367 (724) 454-2295 "
    },
    "80": {
      lat: "35.5634863",
      lng: "-81.0538598",
      name: "Atlantic Coast Fire Trucks",
      description: "4718 Mountain Creek Avenue  Denver NC 28037 (412) 559-5568 acfiretrucks.com"
    },
    "81": {
      lat: "33.57055",
      lng: "-79.0771718",
      name: "Atlantic Coast Fire Trucks",
      description: "37 Stonington Drive  Murrells Inlet SC 29576 (412) 559-5568 acfiretrucks.com"
    },
    "82": {
      lat: "35.103238",
      lng: "-78.91797",
      name: "Atlantic Emergency Solutions",
      description: "4201 Distribution Drive  Fayetteville NC 28311 (910) 488-7961 atlanticemergency.com"
    },
    "83": {
      lat: "38.8953995",
      lng: "-75.739083",
      name: "Bam's Hook and Hose Fire Equipment LLC",
      description: "27733 Burrsville Road  Denton MD 21629 (410) 310-1695 bamshookandhose.com"
    },
    "84": {
      lat: "35.5140347",
      lng: "-78.7424967",
      name: "Batteries of NC",
      description: "81 Medical Dr  Angier NC 27501 +1 919-331-0241 batteriesofnc.com"
    },
    "85": {
      lat: "35.3480561",
      lng: "-78.6891697",
      name: "Batteries of NC",
      description: "7486 NC US 421  South Erwin NC 28339 (919) 331-0241 batteriesofnc.com"
    },
    "86": {
      lat: "32.8228735",
      lng: "-116.9851502",
      name: "Black Box Safety",
      description: "1950 Cordell Court Suite 103 El Cajon CA 92020 619-499-7943 blackboxsafety.com"
    },
    "87": {
      lat: "39.8223518",
      lng: "-74.2058804",
      name: "Blaze Emergency Equipment Company",
      description: "715 Old Shore Rd.  Forked River NJ 8731 609-893-3600 blazeemergency.com"
    },
    "88": {
      lat: "38.3982172",
      lng: "-75.415057",
      name: "Blue Tech",
      description: "7570 Gumboro Road  Pittsville MD 21850 (410) 726-7661 bluetechinstallations.net"
    },
    "89": {
      lat: "43.5679748",
      lng: "-116.1731615",
      name: "BME Fire Trucks, LLC",
      description: "4600 South Apple Street  Boise ID 83716 (208) 338-1444 bmefire.com"
    },
    "90": {
      lat: "33.9319807",
      lng: "-85.0309001",
      name: "Bracketts Fire Inc",
      description: "471 Vinson Mountain Loop  Rockmart GA 30153 (770) 445-1270 brackettfire.com"
    },
    "91": {
      lat: "34.4618071",
      lng: "-86.5551348",
      name: "Brindlee Mountain Fire Apparatus",
      description: "15410 US-231  Union Grove AL 35175 (256) 776-7786 firetruckmall.com"
    },
    "92": {
      lat: "35.4372234",
      lng: "-88.2092853",
      name: "Bruce Fire Equipment LLC",
      description: "5698 Liberty Rd  Scotts Hill TN 38374 (410) 271-5987 "
    },
    "93": {
      lat: "36.6666865",
      lng: "-84.4202825",
      name: "Brush Q Upfitting",
      description: "415 Bob Musgrove Rd  Pine Knot KY 42635 (606) 310-0544 brushqupfitting.com"
    },
    "94": {
      lat: "42.2365529",
      lng: "-71.5631536",
      name: "Bulldog Fire",
      description: "17 Winter Street  Woodville MA 1784 508-435-4200 bulldogfireapparatus.com"
    },
    "95": {
      lat: "42.236557",
      lng: "-71.5631502",
      name: "Bulldog Fire and Emergency Apparatus",
      description: "17 Winter St  Woodville MA 1784 (508) 435-4054 bulldogfireapparatus.com"
    },
    "96": {
      lat: "40.6388613",
      lng: "-82.226112",
      name: "Burgess Ambulance Sales",
      description: "527 Wooster Road  Loudonville OH 44842 800-541-9518 burgessambulance.com"
    },
    "97": {
      lat: "26.0632938",
      lng: "-80.1689785",
      name: "California Custom Sport Trucks",
      description: "4721 Ravenswood Rd.  Fort Lauderdale FL 33312 (954) 981-7223 calcustoms.com"
    },
    "98": {
      lat: "40.3638685",
      lng: "-74.4656599",
      name: "Campbell Supply Company LLC.",
      description: "1015 Cranbury South River Road  South Brunswick NJ 8831 (732) 287-8884 campbellsupply.com"
    },
    "99": {
      lat: "35.7954174",
      lng: "-78.5333419",
      name: "Car Cosmotology Inc",
      description: "5800 Knightdale Boulevard  Knightdale NC 27545-8654 (919) 231-9906 carcosmotology.com"
    },
    "100": {
      lat: "41.3237464",
      lng: "-83.4415432",
      name: "Carina Outfitting",
      description: "101 Maple Street  Bradner OH 43406 419-210-3663 carinaoutfitting.com"
    },
    "101": {
      lat: "36.0528372",
      lng: "-80.9627137",
      name: "Carolina Custom Products",
      description: "6424 Wilkesboro Hwy  Union Grove NC 28689 (704) 592-5454 carolinacustomproducts.com"
    },
    "102": {
      lat: "36.255695",
      lng: "-81.501795",
      name: "Carolina Remounts LLC",
      description: "13526 US Highway 221 S  Fleetwood NC 28626 3368774550 carolinaremounts.com"
    },
    "103": {
      lat: "46.5997954",
      lng: "-120.5061883",
      name: "Cascade Fire & Safety",
      description: "123 S Front St  Yakima WA 98901 (509) 453-6527 cfireinc.com"
    },
    "104": {
      lat: "39.6824592",
      lng: "-89.7286056",
      name: "Chatham Community Fire Protection District",
      description: "1 Fireman Sq  Chatham IL 62629 (217) 483-2121 cfd-il.com"
    },
    "105": {
      lat: "39.3492912",
      lng: "-83.0745791",
      name: "Citizens First Fire Training",
      description: "16689 State Route 28  Chillicothe OH 45601 (937) 305-6369 citizensfirstfiretraining.com"
    },
    "106": {
      lat: "41.7085912",
      lng: "-73.9183177",
      name: "Comm-Lynx",
      description: "103 North Clinton St.  Poughkeepsie NY 12601 (845) 204-3991 comm-lynx.com"
    },
    "107": {
      lat: "40.7859625",
      lng: "-73.0926022",
      name: "Commander Fleet",
      description: "50 Roebling Court  Ronkonkoma NY 11779 (516) 790-5300 commanderfleet.com"
    },
    "108": {
      lat: "41.6210306",
      lng: "-109.232282",
      name: "Communication Technologies, Inc",
      description: "1900 Elk St  Rock Springs WY 82901 (307) 382-5663 comtechradio.com"
    },
    "109": {
      lat: "43.038668",
      lng: "-78.8642033",
      name: "Cornerstone Emergency Equipment",
      description: "  North Tonawanda NY 14120 716-870-0683 cornerstoneemergency.com"
    },
    "110": {
      lat: "41.6073612",
      lng: "-81.071343",
      name: "Countryside Truck Service, Inc.",
      description: "16100 Grand Army of the Republic Hwy  Montville OH 44064 440-968-3505 countrysidetruckservice.com"
    },
    "111": {
      lat: "39.0236501",
      lng: "-84.6858177",
      name: "CR Fleet & Fire Services",
      description: "5732 Commercial Drive  Burlington KY 41005 (859) 283-0911 crfleetandfire.com"
    },
    "112": {
      lat: "37.5610271",
      lng: "-122.315045",
      name: "Cuschieri Auto & Truck Repair",
      description: "1004 South Claremont St.  San Mateo CA 94402 (650) 364-2277 650autorepair.com"
    },
    "113": {
      lat: "32.9920169",
      lng: "-84.5755562",
      name: "CUSTOM TRUCK & BODY WORKS, INC",
      description: "13787 Whitehouse Pkwy  Woodbury GA 30293 (888) 258-9695 customtruckandbodyworks.com"
    },
    "114": {
      lat: "39.996909",
      lng: "-85.2512015",
      name: "D & C Auto Enterprises",
      description: "106 N. Broad Street PO Box 41 Mooreland IN 47360 (765) 524-9783 "
    },
    "115": {
      lat: "31.5794658",
      lng: "-89.5212281",
      name: "Deep South Fire Trucks",
      description: "2342 US 49 North  Seminary MS 39479 1-800-727-4166 deepsouthfiretrucks.com"
    },
    "116": {
      lat: "41.6601329",
      lng: "-86.0292265",
      name: "Delivery Concepts, Inc.",
      description: "29385 County Road 20  Elkhart IN 46517 (574) 444-2698 deliveryconcepts.com"
    },
    "117": {
      lat: "41.9060221",
      lng: "-84.9324181",
      name: "Dependable Fire Apparatus Repair LLC",
      description: "156 N Fremont Rd  Coldwater MI 49036 (517) 617-7030 "
    },
    "118": {
      lat: "44.0495221",
      lng: "-123.1856681",
      name: "Deployed Logix",
      description: "1075 Arrowsmith Street  Eugene OR 97402 541-357-5978 deployedlogix.com"
    },
    "119": {
      lat: "38.6210495",
      lng: "-83.8076653",
      name: "DKC Radio",
      description: "1910 Old Main St Ste 1 Maysville KY 41056 (606) 301-9325 "
    },
    "120": {
      lat: "39.7079343",
      lng: "-86.0710796",
      name: "Donely Safety",
      description: "5546 Elmwood Court  Indianapolis IN 46203 (317) 786-2268 donleysafety.com"
    },
    "121": {
      lat: "39.1156015",
      lng: "-75.7437472",
      name: "DPC EMERGENCY EQUIPMENT",
      description: "335 Strauss Ave.  Marydel DE 19964 (302) 492-1245 dpcemergency.com"
    },
    "122": {
      lat: "41.3642332",
      lng: "-85.7360974",
      name: "Dunnys Pump Service",
      description: "5701 E 900 N  Syracuse IN 46567 (574) 526-1136 dunnyspumpservice.com"
    },
    "123": {
      lat: "41.3407558",
      lng: "-72.7508382",
      name: "E.J. Boughton Company",
      description: "2344 Foxon Rd.  North Branford CT 6471 (203) 483-1909 "
    },
    "124": {
      lat: "40.059458",
      lng: "-85.6568748",
      name: "Edens Outfitters",
      description: "1839 E 53rd St Suite 5  Anderson IN 46013 (765) 278-0906 edensoutfitters.com"
    },
    "125": {
      lat: "40.3848143",
      lng: "-105.0693176",
      name: "Elevated Fire Supply",
      description: "546 8th St SE  Loveland CO 80537 (970) 889-0206 elevatedfiresupply.com"
    },
    "126": {
      lat: "32.2646244",
      lng: "-90.1756182",
      name: "Emergency Equipment Professionals",
      description: "109 Aero Smith Drive  Richland MS 39218 (866) 764-1822 emergencyequipment.us"
    },
    "127": {
      lat: "34.9553719",
      lng: "-90.0348139",
      name: "Emergency Equipment Professionals",
      description: "5237 Halls Mill Road Bldg I  Hornlake MS 38637 (866) 764-1822 emergencyequipment.us"
    },
    "128": {
      lat: "38.5773112",
      lng: "-90.1757107",
      name: "Emergency Lights Specialists, LLC",
      description: "3639 Falling Springs Rd  Cahokia IL 62206  facebook.comEmergencyLightsSpecialist"
    },
    "129": {
      lat: "35.7648079",
      lng: "-91.6378977",
      name: "Emergency Repair of Arkansas",
      description: "1515 15th Street  Batesville AR 72501 (870) 612-8319 facebook.comEmergencyRepairofArkansas"
    },
    "130": {
      lat: "36.2384536",
      lng: "-81.5121416",
      name: "Emergency Transportation Associates, LLC",
      description: "307 E Yuma Lane  Deep Gap NC 28618 (882) 355-9755 joineta.com"
    },
    "131": {
      lat: "33.8529453",
      lng: "-117.8673605",
      name: "Emergency Vehicle Group",
      description: "2883 East Coronado Street  Anaheim CA 92806 (714) 238-0110 evginc.net"
    },
    "132": {
      lat: "33.0540636",
      lng: "-80.1966767",
      name: "Emergency Vehicle Solutions",
      description: "148 West Medina Street  Summerville SC 294383 (843) 709-4211 evs911.com"
    },
    "133": {
      lat: "39.6367208",
      lng: "-77.8103703",
      name: "Emergency Vehicle Specialist",
      description: "16121 Business Parkway  Hagerstown MD 21740 (301) 739-7973 evspecialist.com"
    },
    "134": {
      lat: "28.8062121",
      lng: "-81.2741581",
      name: "ETR",
      description: "700 S French Ave  Sanford FL 32771 844-612-8148 etrvehicles.com"
    },
    "135": {
      lat: "45.0313106",
      lng: "-93.1002412",
      name: "Everest Emergency Vehicles, Inc.",
      description: "8 South Owasso Blvd.  Little Canada MN 55117 651-690-1867 everestev.com"
    },
    "136": {
      lat: "42.7826615",
      lng: "-86.0792062",
      name: "EVP",
      description: "670 East 16th St  Holland MI 49423 800-320-9749 emergencyvehiclesplus.com"
    },
    "137": {
      lat: "40.008411",
      lng: "-79.0780831",
      name: "F.A.S.T. of the Allegheny Mountains",
      description: "  Somerset PA 15501 (814) 443-6313 "
    },
    "138": {
      lat: "29.5606243",
      lng: "-98.2846602",
      name: "FARRWEST SPECIALTY VEHICLES, LLC.",
      description: "108 Commercial Pl  Schertz TX 78154 (210) 566-1857 farrwestsv.com"
    },
    "139": {
      lat: "39.1456358",
      lng: "-77.7180682",
      name: "Fastlane Emergency Vehicles",
      description: "37241 E Richardson Ln  Purcellville VA 20132 (540) 338-0901 flev.com"
    },
    "140": {
      lat: "40.1727478",
      lng: "-74.0271271",
      name: "FF1 PROFESSIONAL SAFETY SERVICES",
      description: "1700 Main Street, Suite 4  Belmar NJ 7719 (732) 276-1066 ff1.com"
    },
    "141": {
      lat: "41.0764003",
      lng: "-74.6672604",
      name: "FF1 PROFESSIONAL SAFETY SERVICES",
      description: "34 Wilson Drive  Sparta NJ 7871 (973) 940-3061 ff1.com"
    },
    "142": {
      lat: "40.32226",
      lng: "-76.8921829",
      name: "Fire & Rescue Products",
      description: "4230 Industrial Road  Harrisburg PA 17110 800-637-3473 firerps.com"
    },
    "143": {
      lat: "40.5603852",
      lng: "-74.4159566",
      name: "Fire & Safety Services, Ltd.",
      description: "200 Ryan Street  South Plainfield NJ 7080 (800) 400-8017 f-ss.com"
    },
    "144": {
      lat: "38.0411436",
      lng: "-85.6780393",
      name: "FIRE & SPECIALTY EQUIPMENT COMPANY",
      description: "235 Rogers Dr  Shepherdsville KY 40165 (502) 957-2145 firespecialtyequip.com"
    },
    "145": {
      lat: "40.2070534",
      lng: "-74.63814",
      name: "Fire Apparatus Repair, Inc.",
      description: "2740 Kuser Road  Hamilton NJ 8691 (609) 689-2888 fireapparatusrepair.nethome"
    },
    "146": {
      lat: "34.0693393",
      lng: "-117.3661921",
      name: "Fire Apparatus Solutions",
      description: "1762 S Sycamore Ave  Rialto CA 92376 (909) 879-7354 fasservice.orgindex.html"
    },
    "147": {
      lat: "34.0805708",
      lng: "-117.4871502",
      name: "Fire Apparatus Solutions",
      description: "14562 Manzanita Drive  Fontana CA 92335 (714) 357-9706 fasservice.orgindex.html"
    },
    "148": {
      lat: "48.5382618",
      lng: "-123.0306986",
      name: "Fire Fleet Maintenance LLC",
      description: "415-1 Carter Ave  Friday Harbor WA 98250 (360) 317-6109 firefleetmaintenance.com"
    },
    "149": {
      lat: "37.2260098",
      lng: "-93.2550126",
      name: "Fire Master Fire Equipment",
      description: "2049 East Division St.  Springfield MO 65803 (800) 641-4724 firemaster.com"
    },
    "150": {
      lat: "44.0436209",
      lng: "-92.512034",
      name: "Fire Safety USA, Inc.",
      description: "3253 19th St NW  Rochester MN 55901 (507) 529-8444 firesafetyusa.com"
    },
    "151": {
      lat: "41.94289",
      lng: "-80.3062943",
      name: "Fire-Fly Fire Equipment",
      description: "9525 Franklin Center Road  Cranseville PA 16410 (814) 774-8036 fireflyfire.comindex.htm"
    },
    "152": {
      lat: "32.4549985",
      lng: "-95.4263423",
      name: "Fire-Teck",
      description: "12950 County Road 411  Tyler TX 75706 903 881 8138 fire-teck.com"
    },
    "153": {
      lat: "42.6464308",
      lng: "-76.3694036",
      name: "Firehouse Apparatus Inc.",
      description: "13219 State Route 90  Locke NY 13092 (315) 497-0106 firehouseapparatus.com"
    },
    "154": {
      lat: "37.2259713",
      lng: "-93.2549839",
      name: "Firemaster Fire Apparatus",
      description: "2049 East Division  Springfield MO 65803 417-865-8713 firemaster.com"
    },
    "155": {
      lat: "38.5046894",
      lng: "-90.648016",
      name: "Firemaster Fire Apparatus",
      description: "1299 West 5th St  Eureka MO 63025 636-938-9100 firemaster.com"
    },
    "156": {
      lat: "40.8408264",
      lng: "-72.8847317",
      name: "Firematic",
      description: "10 Ramsay RdÂ   Shirley NY 11967 631-924-3181 "
    },
    "157": {
      lat: "40.8408264",
      lng: "-72.8847317",
      name: "Firematic Supply Co.",
      description: "10 Ramsay Road  East Yaphank NY 11967 631-924-3181 firematic.comindex.htm"
    },
    "158": {
      lat: "41.6430537",
      lng: "-72.6691093",
      name: "Firematic Supply Co.",
      description: "651 Brook Street  Rocky Hill CT 6067 860-571-7370 firematic.comindex.htm"
    },
    "159": {
      lat: "42.142905",
      lng: "-71.491841",
      name: "Firematic Supply Co.",
      description: "23 Birch Street  Milford MA 1757 978-422-3560 firematic.comindex.htm"
    },
    "160": {
      lat: "41.4680973",
      lng: "-73.5808526",
      name: "Firematic Supply Co.",
      description: "50 Jon Barrett Road  Patterson NY 12563 914-468-0168 firematic.comindex.htm"
    },
    "161": {
      lat: "42.7492678",
      lng: "-74.0432774",
      name: "Firematic Supply Co.",
      description: "374 Wastern Turnpike  Altamont NY 12009 518-730-0401 firematic.comindex.htm"
    },
    "162": {
      lat: "43.0898261",
      lng: "-77.8932645",
      name: "Firematic Supply Co.",
      description: "340 Sanford Road South  Churchville NY 14428 585-293-1688 firematic.comindex.htm"
    },
    "163": {
      lat: "42.9919464",
      lng: "-78.8939847",
      name: "Firematic Supply Co.",
      description: "107 Pearce Avenue  Tonawanda NY 14150 716-876-1688 firematic.comindex.htm"
    },
    "164": {
      lat: "43.061393",
      lng: "-76.053761",
      name: "Firematic Supply Co.",
      description: "5994 Wilbur Road  East Syracuse NY 13057 315-299-8664 firematic.comindex.htm"
    },
    "165": {
      lat: "36.0397496",
      lng: "-115.0370535",
      name: "Firetrucks Unlimited",
      description: "1175 Center Point Dr  Henderson NV 89074 (702) 558-3352 FiretrucksUnlimited.com"
    },
    "166": {
      lat: "36.0754183",
      lng: "-79.0997347",
      name: "First Choice Fire and Safety Inc.",
      description: "  Hillsborough NC 27278 1-(800) 753-2350 firstchoicetrucks.net"
    },
    "167": {
      lat: "35.7060805",
      lng: "-81.6418952",
      name: "First Due Emergency Vehicle Services",
      description: "2601 Mount Home Church Rd  Morganton NC 28655 (828) 475-9541 firstdueevs.com"
    },
    "168": {
      lat: "40.0174802",
      lng: "-74.306603",
      name: "First Priority Group",
      description: "2444 Ridgeway Blvd.  Manchester NJ 8759 (973) 347-4321 1fpg.com"
    },
    "169": {
      lat: "27.4052574",
      lng: "-82.5474336",
      name: "Flash Equipment Incorporated",
      description: "7602 15Th St E  Sarasota FL 34243 9417568686 flashequipment.com"
    },
    "170": {
      lat: "40.3517901",
      lng: "-79.8647474",
      name: "FLASHOVER FIRE APPARATUS LLC",
      description: "409 Walnut Street Suite 203 McKeesport PA 15132 412-535-1321 flashoverfire.com"
    },
    "171": {
      lat: "32.351771",
      lng: "-95.2697012",
      name: "Fleet Plus",
      description: "2517E Erwin ST  Tyler TX 75702 903-705-7017 fleetplus.org"
    },
    "172": {
      lat: "41.7732587",
      lng: "-88.1479553",
      name: "Fleet Safety Supply",
      description: "127-A S. Washington St  Naperville IL 60540 (630) 527-1341 fleetsafetysupply.com"
    },
    "173": {
      lat: "41.9324066",
      lng: "-72.6569527",
      name: "Fleetmasters Sales & Service",
      description: "422 Spring St  Windsor Locks CT 6096 (860) 292-8553 fleetmastersfire.com"
    },
    "174": {
      lat: "42.6828458",
      lng: "-71.1846309",
      name: "Fleetmasters Sales & Service",
      description: "71 Glenn St.  Lawrence MA 1843 (781) 245-5045 fleetmastersfire.com"
    },
    "175": {
      lat: "41.7941444",
      lng: "-89.7310267",
      name: "Foster Coach Sales",
      description: "903 Prosperity Drive  Sterling IL 61081 (800) 369-4215 fostercoach.com"
    },
    "176": {
      lat: "33.8493608",
      lng: "-84.0343571",
      name: "Gellman Upfitting",
      description: "2321 Westridge Drive  Snellville GA 30078 678-709-2179 gellmanupfitting.com"
    },
    "177": {
      lat: "36.6737968",
      lng: "-78.7537465",
      name: "General Fire Equipment",
      description: "5090 Ramble Rd  Virgilina VA 24598 (434) 579-7581 generalfireequip.com"
    },
    "178": {
      lat: "40.7839797",
      lng: "-89.0878215",
      name: "Genesis Network Solutions, INC DBA Pro Fleet 360",
      description: "1328 County Road 2375 East  El Paso IL 61738 309-244-4272 profleet360.com"
    },
    "179": {
      lat: "40.0427523",
      lng: "-76.1980361",
      name: "Glick Fire Equipment",
      description: "350 Mill Creek Road  Bird-in-Hand PA 17505 (717) 299-4120 glickfire.com"
    },
    "180": {
      lat: "40.7943302",
      lng: "-80.0989724",
      name: "GLICK FIRE EQUIPMENT CO",
      description: "2348 Evans City Road  Zelienople PA 16063 (724) 452-5553 glickfire.com"
    },
    "181": {
      lat: "41.075475",
      lng: "-77.482782",
      name: "GLICK FIRE EQUIPMENT CO",
      description: "7484 Nittany Valley Drive  Mill Hall PA 17751 (570) 858-0500 glickfire.com"
    },
    "182": {
      lat: "38.4886416",
      lng: "-121.3978453",
      name: "Golden State Fire",
      description: "7400 Reese Road  Sacramento CA 95828 916-330-1638 goldenstatefire.com"
    },
    "183": {
      lat: "34.1656875",
      lng: "-88.7095672",
      name: "Goldy's Fire Apparatus",
      description: "115 Godfrey Road  Tupelo MS 38801 (662) 401-5152 goldysfire.com"
    },
    "184": {
      lat: "41.5936555",
      lng: "-73.1069434",
      name: "Gowans-Knight Co. Inc.",
      description: "49 Knight Street  Watertown CT 6795 (860) 274-8801 gowansknight.com"
    },
    "185": {
      lat: "40.6937099",
      lng: "-111.9003156",
      name: "Graham Fire Apparatus",
      description: "3566 South 300 West  South Salt Lake UT 84115 (385) 955-5020 grahamfire.com"
    },
    "186": {
      lat: "41.6922573",
      lng: "-104.1692311",
      name: "Grassy Knoll Enterprises",
      description: "1682 County Road 51  La Grange WY 82221 (307) 421-7193 gkefire.com"
    },
    "187": {
      lat: "41.9883279",
      lng: "-71.2992529",
      name: "Greenwood Emergency Group",
      description: "530 John L Dietsch Blvd  Attleborough Falls MA 2763 508-695-7138 greenwoodev.com"
    },
    "188": {
      lat: "33.4102334",
      lng: "-112.034689",
      name: "H & E EQUIPMENT SERVICES",
      description: "4010 S. 22nd Street  Phoenix AZ 85040 602-232-0600 he-equipment.com"
    },
    "189": {
      lat: "42.5257274",
      lng: "-83.5452154",
      name: "Halt Fire",
      description: "50168 W. Pontiac Trail Unit 5 Wixom MI 48393 (248) 669-0800 haltfire.net"
    },
    "190": {
      lat: "43.0505388",
      lng: "-76.0669552",
      name: "Har-Rob Fire Apparatus Service & Sales, Inc.",
      description: "5089 Whirlybird Ln  Syracuse NY 13057 (800) 724-2590 "
    },
    "191": {
      lat: "38.8516838",
      lng: "-99.2566372",
      name: "Hays Fire and Rescue",
      description: "1151 Moe Rd  Hays KS 67601 (785) 628-0600 haysfireandrescue.net"
    },
    "192": {
      lat: "43.6071315",
      lng: "-96.8136642",
      name: "Heiman Fire Equipment",
      description: "25814 Rudolph Ave  Sioux Falls SD 57107 (605) 543-5510 heimanfire.com"
    },
    "193": {
      lat: "40.0764632",
      lng: "-83.1784657",
      name: "Herb Fire",
      description: "  Amlin OH 43002 (614)329-1610 herbfire.com"
    },
    "194": {
      lat: "39.9307325",
      lng: "-82.8727623",
      name: "Heritage Fire Equipment",
      description: "2162 CLOVERLEAF STREET EAST COLUMBUS  COLUMBUS OH 43232 (844) 730-5100 heritagefireequipment.com"
    },
    "195": {
      lat: "37.7550485",
      lng: "-120.8488118",
      name: "Hi-Tech Emergency Vehicle Service LLC",
      description: "444 W. GREGER ST.  Oakdale CA 95361 (209) 847-3042 mail.hitechevs.comindex.htm"
    },
    "196": {
      lat: "35.5942672",
      lng: "-78.1368746",
      name: "Holland's Fire & Fleet",
      description: "128 Bay Valley Rd  Kenly NC 27542 (252) 205-4242 facebook.compHollands-Fire-Fleet-100090680358681"
    },
    "197": {
      lat: "39.8395526",
      lng: "-85.9267015",
      name: "Hoosier Fire Equipment, Inc.",
      description: "3863 N. Commercial Parkway  Greenfield IN 46140 317-891-8375 www.hoosierfire.com"
    },
    "198": {
      lat: "42.1710363",
      lng: "-85.8431572",
      name: "HS Fleet Services, LLC",
      description: "625 North St.  Lawton MI 49065 (269) 299-0287 hsfleet.services"
    },
    "199": {
      lat: "41.3634397",
      lng: "-73.6149187",
      name: "Hudson Valley Fire LLC",
      description: "69 Fields Ln  Brewster NY 10509 (845) 363-1810 hudsonvalleyfire.com"
    },
    "200": {
      lat: "47.2109647",
      lng: "-122.4869698",
      name: "Hughes Fire",
      description: "5011 S. Burlington Avenue Suite A Tacoma WA 98409 541-747-0072 hughesfire.com"
    },
    "201": {
      lat: "44.0655536",
      lng: "-123.0411617",
      name: "Hughes Fire Equipment",
      description: "910 Shelley St  Springfield OR 97477 541-747-0072 hughesfire.com"
    },
    "202": {
      lat: "33.45809",
      lng: "-112.1719434",
      name: "Hughes Fire Equipment",
      description: "5159 W. Roosevelt Street  Phoenix AZ 85043 480-745-1573 hughesfire.com"
    },
    "203": {
      lat: "21.3337389",
      lng: "-158.0823892",
      name: "Hughes Fire Equipment",
      description: "  Kapolei HI 96707 480-745-1573 hughesfire.com"
    },
    "204": {
      lat: "43.636601",
      lng: "-116.4359952",
      name: "Hughes Fire Equipment",
      description: "3396 W. Nelis Drive  Meridan ID 83646 541-747-0072 hughesfire.com"
    },
    "205": {
      lat: "36.0872559",
      lng: "-115.045135",
      name: "Hughes Fire Equipment",
      description: "5810 E. Emerald Ave  Las Vegas NV 89122 541-747-0072 hughesfire.com"
    },
    "206": {
      lat: "45.5751628",
      lng: "-122.6357853",
      name: "Hughes Fire Equipment",
      description: "2901 NE Columbia Boulevard  Portland OR 97211 541-747-0072 hughesfire.com"
    },
    "207": {
      lat: "44.6225763",
      lng: "-123.0608159",
      name: "Hughes Fire Equipment",
      description: "1980 Fescue Street Suite B Albany OR 97322 541-747-0072 hughesfire.com"
    },
    "208": {
      lat: "46.1998568",
      lng: "-119.0130618",
      name: "Hughes Fire Equipment",
      description: "64 Gateway Rd Suite 130 Burbank WA 99323 480-745-1573 hughesfire.com"
    },
    "209": {
      lat: "48.3857044",
      lng: "-122.3264368",
      name: "Hughes Fire Equipment",
      description: "1215 E. Hickox Rd Suite 101 Mount Vernon WA 98274 480-745-1573 hughesfire.com"
    },
    "210": {
      lat: "38.2940546",
      lng: "-75.7177089",
      name: "Ignite Fire Apparatus",
      description: "25361 Collins Wharf Rd.  Eden MD 21822 (410) 479-9027 ignitefa.com"
    },
    "211": {
      lat: "36.1001161",
      lng: "-78.8489519",
      name: "Infinity Communications Group",
      description: "5201 International Drive  Durham NC 27712 (919) 698-6983 infinity24-7.com"
    },
    "212": {
      lat: "46.750095",
      lng: "-112.300523",
      name: "J C Communications",
      description: "248 Grand Street  Marysville MT 59640 406-916-8546 facebook.comjccommunicationsmt"
    },
    "213": {
      lat: "40.1935803",
      lng: "-79.5904996",
      name: "J. Marcoz Inc.",
      description: "973 S. CENTER AVE  HUNKER PA 15639 412-816-2320 facebook.comjmarcozemergencyvehicle"
    },
    "214": {
      lat: "43.1159907",
      lng: "-76.192227",
      name: "J.P.B Fire Services Inc.",
      description: "4675 Burr Drive  Liverpool NY 13088 (844) 572-3473 jpbfire.com"
    },
    "215": {
      lat: "43.1935219",
      lng: "-76.1676792",
      name: "Jerome Fire Equipment",
      description: "8721 Caughdenoy Rd.  Clay NY 13041 315-699-5288 jeromefire.com"
    },
    "216": {
      lat: "41.1056215",
      lng: "-74.0344717",
      name: "Jesse's Power Shop",
      description: "81 NY-59  Spring Valley NY 10977 845-352-2586 www.jessespowershop.com"
    },
    "217": {
      lat: "33.7197385",
      lng: "-117.2897012",
      name: "JOHNSON EQUIPMENT COMPANY",
      description: "21155 WALLACE AVE  PERRIS CA 92570 (951) 940-0606 johnson-equipment.comindex.php"
    },
    "218": {
      lat: "37.1207777",
      lng: "-93.1429125",
      name: "Jon's Mid America Fire Apparatus",
      description: "7037 E. US Highway 60  Rogersville MO 65742 417-887-0534 jonsmidamerica.com"
    },
    "219": {
      lat: "40.1134569",
      lng: "-76.0532014",
      name: "Keystone Emergency Vehicles",
      description: "307 Twin Springs Court  New Holland PA 17557 (717) 292-7977 keystone-emergency.com"
    },
    "220": {
      lat: "40.4670817",
      lng: "-80.0877464",
      name: "Keystone Fire Apparatus",
      description: "1751 McKees Rocks Rd.  McKees Rock PA 15136-1607 (412) 771-7722 keystonefireapparatus.com"
    },
    "221": {
      lat: "42.8887992",
      lng: "-85.8445983",
      name: "Kleyn Mobile Repair, LLC.",
      description: "6680 Wilshere Dr  Jenison MI 49428 (616) 209-7007 autorepairjenisonmi.com"
    },
    "222": {
      lat: "39.8785153",
      lng: "-75.4571105",
      name: "KML Transport, LLC",
      description: "6 Mt. Pleasant Rd Suite D Aston PA 19014 (484) 840-8241 kmlemergencyvehicle.com"
    },
    "223": {
      lat: "40.2998234",
      lng: "-79.5951486",
      name: "Kush Kustoms LLC",
      description: "151 Lopes Lane  Greensburg PA 15601 (878) 214-8936 "
    },
    "224": {
      lat: "36.3059532",
      lng: "-80.8441009",
      name: "L&A Emergency Equipment Inc.",
      description: "120 Country Club Dr.  State Road NC 28676 (336) 526-3748 "
    },
    "225": {
      lat: "43.8252855",
      lng: "-71.2488303",
      name: "Lakes Region Fire Apparatus",
      description: "688 Ossipee Mountain Hwy  Tamworth NH 3886 (603) 323-7117 lakesfire.com"
    },
    "226": {
      lat: "41.51592",
      lng: "-88.2105988",
      name: "Legacy Fire Apparatus",
      description: "600 Earl Road  Shorewood IL 60404 (877) 374-0353 legacyfireapparatus.com"
    },
    "227": {
      lat: "40.7399427",
      lng: "-75.2986264",
      name: "Lehigh Valley Fleet Solutions",
      description: "314 Industrial Dr.  Nazareth PA 18064 (610) 849-6016 lvfleet.com"
    },
    "228": {
      lat: "38.800829",
      lng: "-90.8175614",
      name: "Leo M. Ellebracht Company",
      description: "104 Mullach Ct Ste. 1028 Wentzville MO 63385 (636) 332-6985 lmecompany.com"
    },
    "229": {
      lat: "34.8963165",
      lng: "-80.9607318",
      name: "Lesslie Welding and Fabrication",
      description: "2975 Lesslie Hwy.  Rock Hill SC 29730 (803) 980-0099 lessliewelding.com"
    },
    "230": {
      lat: "40.4126947",
      lng: "-75.8448391",
      name: "Levan Machine & Truck Equipment",
      description: "3417 Pricetown Road  Fleetwood PA 19522 (610) 944-7455 levanmachine.com"
    },
    "231": {
      lat: "38.2554335",
      lng: "-77.5073912",
      name: "Liberty Fleet Solutions",
      description: "10879 Houser Dr  Fredericksburg VA 22408 (540) 898-8933 libertyequipment.com"
    },
    "232": {
      lat: "35.1223735",
      lng: "-79.4136363",
      name: "Light the Way Emergency Vehicles",
      description: "354 Parkway Drive  Aberdeen NC 28315 (910)690-7974 lightthewaync.com"
    },
    "233": {
      lat: "26.666993",
      lng: "-81.8037414",
      name: "Lighting Wireless Solutions",
      description: "5500 Division Drive  Fort Myers FL 33905 239-481-8700 lwsinc.netindex.htm"
    },
    "234": {
      lat: "37.5976734",
      lng: "-76.513822",
      name: "Logan Fire Apparatus, Inc.",
      description: "1757 Healys Road Suite E Locust Hill VA 23092 (757) 810-7669 loganfireapparatus.com"
    },
    "235": {
      lat: "29.9310026",
      lng: "-95.3203021",
      name: "Lone Star Emergency",
      description: "4553 Aldine Bender  Houston TX 77032 713-376-9585 lonestareg.com"
    },
    "236": {
      lat: "38.0366313",
      lng: "-84.8923733",
      name: "LW Outfitters",
      description: "250 East Court St.  Lawrenceburg KY 40342 (502) 839-6334 lwoutfitters.com"
    },
    "237": {
      lat: "39.0083388",
      lng: "-84.4700607",
      name: "LW Outfitters",
      description: "1426 Gloria Terell Dr.  Wilder KY 41076 (859) 241-1430 lwoutfitters.com"
    },
    "238": {
      lat: "41.8196816",
      lng: "-79.8196503",
      name: "Lynn Kolaja Fire Equipment Sales, Inc.",
      description: "36820 Lake Rd.  Union City PA 16438 (814) 694-3240 kolaja.com"
    },
    "239": {
      lat: "35.4664229",
      lng: "-97.2096338",
      name: "M&M Metalworx",
      description: "174 Woodlake Dr  ,OK 73020  Choctaw OK 73020 (405) 620-1891 facebook.compM-M-Metal-Worx-MFG-Of-Brush-Trucks-And-Rescue-Units-100063194410170"
    },
    "240": {
      lat: "44.324313",
      lng: "-96.9272135",
      name: "M&T Fire and Safety",
      description: "105 Kasan Ave. PO Box 167 Volga SD 57071 605-627-5165 mtfiresafety.com"
    },
    "241": {
      lat: "44.7384",
      lng: "-93.1955197",
      name: "MACQUEEN EMERGENCY",
      description: "14607 Felton Ct #109  Apple Valley MN 55124 (952) 683-1054 macqueeneq.com"
    },
    "242": {
      lat: "41.4188236",
      lng: "-73.6710502",
      name: "MAGPRO Services, LLC",
      description: "20 Day Road  Carmel NY 10512 845-225-2304 magproservice.com"
    },
    "243": {
      lat: "41.0551307",
      lng: "-96.0568523",
      name: "Main Response",
      description: "9040 Raven Dr  Louisville NE 68037 (877) 461-5798 mainresponse.com"
    },
    "244": {
      lat: "43.1696444",
      lng: "-95.8579704",
      name: "MAINTAINER CORP. OF IOWA, INC.",
      description: "1701 2nd Ave  Sheldon IA 51201 (712) 324-5001 maintainer.com"
    },
    "245": {
      lat: "32.5153313",
      lng: "-97.4723479",
      name: "Marshal Stuff, Inc.",
      description: "4625 Homestead Way  Joshua TX 76058 (817) 360-2224 marshalstuff.com"
    },
    "246": {
      lat: "36.7787503",
      lng: "-76.3938509",
      name: "Matheny Fire & Emergency",
      description: "4144 S. Military Highway  Chesapeake VA 23321 (301) 797-1410 mathenyfire.com"
    },
    "247": {
      lat: "38.6342896",
      lng: "-77.2540755",
      name: "Matheny Fire & Emergency",
      description: "14716 Industry Court  Woodbridge VA 22191 (301) 797-1410 mathenyfire.com"
    },
    "248": {
      lat: "38.3806311",
      lng: "-82.5804572",
      name: "Matheny Fire & Emergency",
      description: "1375, US Rt 52  Kenova WV 25530 (301) 797-1410 mathenyfire.com"
    },
    "249": {
      lat: "39.18862",
      lng: "-81.5269425",
      name: "Matheny Fire & Emergency",
      description: "50 Matheny Lane  Mineral Wells WV 26150  mathenyfire.com"
    },
    "250": {
      lat: "39.5931099",
      lng: "-77.6754895",
      name: "Matheny Fire and Emergency",
      description: "19932 Beaver Creek Road  Hagerstown MD 21740 (301) 797-1410 mathenyfire.com"
    },
    "251": {
      lat: "26.1766246",
      lng: "-80.1574795",
      name: "Matheny Fire and Emergency",
      description: "4120 NW 10th Avenue  Oakland Park FL 33309 (800) 524-6072 mathenymotors.com"
    },
    "252": {
      lat: "29.1795629",
      lng: "-82.1955399",
      name: "Matheny Fire and Emergency",
      description: "725 SW 46th Avenue  Ocala FL 34474 (800) 524-6072 mathenymotors.com"
    },
    "253": {
      lat: "30.4353131",
      lng: "-84.3595335",
      name: "Matheny Fire and Emergency",
      description: "4900 Blountstown Highway  Tallahassee FL 32304 (800) 524-6072 mathenymotors.com"
    },
    "254": {
      lat: "35.1996428",
      lng: "-106.5835443",
      name: "MHQ West",
      description: "5601 Balloon Fiesta Parkway NE Suite C Albuquerque NM 87113 (833) 455-0504 mhqwest.com"
    },
    "255": {
      lat: "33.3114551",
      lng: "-111.968551",
      name: "MHQ West",
      description: "550 N. 54th Street  Chandler AZ 85226 (833) 455-0503 mhqwest.com"
    },
    "256": {
      lat: "40.260157",
      lng: "-89.229417",
      name: "Mid-State Fire Repair",
      description: "331 Southeast Vine St.  Atlanta IL 61723 (217) 638-0794 midstatefire.biz"
    },
    "257": {
      lat: "40.2493896",
      lng: "-76.8088005",
      name: "MJR Equipment, Inc.",
      description: "4210 Chambers Hill Rd  Harrisburg PA 17111 (717) 901-9070 sfurst@mjrequipment.com"
    },
    "258": {
      lat: "42.6058572",
      lng: "-89.6698654",
      name: "Monroe Truck Equipment Inc.",
      description: "1051 West 7th Street  Monroe WI 53566 (800) 356-8134 monroetruck.com"
    },
    "259": {
      lat: "48.1769014",
      lng: "-114.2998944",
      name: "Montana Truck Works",
      description: "3576 US Hwy 93 South Unit D Kalispell MT 59901 (406) 300-4055 mt-truckworks.com"
    },
    "260": {
      lat: "38.5843817",
      lng: "-94.8578404",
      name: "MULTIPLICITY",
      description: "1608 Industrial Park Drive  Paola KS 66071 913-229-4032 multiplicityks.com"
    },
    "261": {
      lat: "26.2518097",
      lng: "-98.2425528",
      name: "Municipal Fire Apparatus Specialists",
      description: "5200 N 26th St.  McAllen TX 78504 (956) 630-3473 municipalfire.net"
    },
    "262": {
      lat: "38.3583413",
      lng: "-76.4389549",
      name: "Nelson Emergency Vehicle Lighting",
      description: "  Lusby MD 20657 443-624-8226 www.facebook.comnelsonevl"
    },
    "263": {
      lat: "38.5107551",
      lng: "-76.6474982",
      name: "Nelson Emergency Vehicle Lighting",
      description: "151 Schooner Lane  Prince Frederick MD 20678 (443) 624-8226 "
    },
    "264": {
      lat: "40.7394471",
      lng: "-73.6721079",
      name: "Neville Apparatus",
      description: "37 Denton Ave  New Hyde Park NY 11040  nevillefleet.com"
    },
    "265": {
      lat: "36.4395224",
      lng: "-80.0506217",
      name: "New Traditions, Inc.",
      description: "1500 Martin Farm Road  Madison NC 27025 (336) 552-8966 ntifire.com"
    },
    "266": {
      lat: "44.8852676",
      lng: "-94.0305212",
      name: "North Central Emergency Vehicles",
      description: "18448 County Road 9  Lester Prairie MN 55354 888-785-3375 ncemergencyvehicles.com"
    },
    "267": {
      lat: "44.8852676",
      lng: "-94.0305212",
      name: "North Central Emergency Vehicles",
      description: "18448 County Road 9  Lester Prairie MN 55354 888-785-3375 ncemergencyvehicles.com"
    },
    "268": {
      lat: "43.1118093",
      lng: "-76.2507538",
      name: "North Eastern Rescue Vehicles",
      description: "10 Dwight Park Dr  Syracuse NY 13209 (800) 553-6094 nervinc.com"
    },
    "269": {
      lat: "40.906793",
      lng: "-74.5717155",
      name: "Northeast Communications",
      description: "244 E. Union Turnpike  Wharton NJ 7885 (973) 328-4000 northeastcommunications.com"
    },
    "270": {
      lat: "41.5407445",
      lng: "-72.887881",
      name: "Northeastern Fire Associates, Inc.",
      description: "128 Blacks Road  Cheshire CT 6410 (203) 272-9228 northeasternfire.com"
    },
    "271": {
      lat: "37.0855983",
      lng: "-121.6064254",
      name: "Northern California's Emergency Vehicle Installations",
      description: "200 East San Martin Rd Unit 960 San Martin CA 95046 (408) 509-6271 norcalevi.com"
    },
    "272": {
      lat: "48.0632864",
      lng: "-114.0726134",
      name: "Northwest Fire Services",
      description: "PO Box 821  Bigfork MT 59911 (406) 837-0118 northwestfireservices.com"
    },
    "273": {
      lat: "36.3827394",
      lng: "-81.4974088",
      name: "Northwestern Emergency Vehicles",
      description: "NWEV Drive West  Jeffereson NC 28694 336-977-1015 NWEV.com"
    },
    "274": {
      lat: "30.1271364",
      lng: "-95.6644439",
      name: "Novamaxa",
      description: " 26980 Decker Prairie-Rosehill Rd Magnolia TX 77355 (832) 521-3770 novamaxa.com"
    },
    "275": {
      lat: "41.9295524",
      lng: "-71.505715",
      name: "On Scene, LLC",
      description: "52 W. Reservoir Rd.  Smithfield RI 2917 (401) 429-8007 onsceneservice.com"
    },
    "276": {
      lat: "36.0339199",
      lng: "-90.5169772",
      name: "Paragould Communications",
      description: "100 Arnold Ln  Paragould AR 72450 (870) 239-9605 paragouldcommunications.com"
    },
    "277": {
      lat: "33.9113036",
      lng: "-84.2236806",
      name: "Peach State Truck Centers",
      description: "6535 Crescent Drive  Norcross GA 30071 (770) 449-5300 peachstatetrucks.com"
    },
    "278": {
      lat: "41.2096071",
      lng: "-80.7631971",
      name: "Penn Care",
      description: "1317 North Road  Niles OH 44446 (877) 287-9715 penncare.net"
    },
    "279": {
      lat: "34.1394898",
      lng: "-117.9176687",
      name: "Performance Truck Repair",
      description: "892 W 10th St  Azusa CA 91702 (626) 482-2502 "
    },
    "280": {
      lat: "45.158289",
      lng: "-89.148739",
      name: "Pomasl Fire Equipment, Inc",
      description: "1918 Neva Road  Antigo WI 54409 715-623-7454 pomasl.com"
    },
    "281": {
      lat: "41.990055",
      lng: "-73.9917721",
      name: "Premier Fire Apparatus",
      description: "68 Leggs Mills Road  Lake Katrine NY 12449 (845)-750-3149 premierfireapp.com"
    },
    "282": {
      lat: "43.0913396",
      lng: "-76.1396524",
      name: "Premier Fire Apparatus",
      description: "108 Anderson Ave.  Syracuse NY 13208 (315) 870-9040 premierfireapp.com"
    },
    "283": {
      lat: "42.7251554",
      lng: "-73.8589705",
      name: "Premier Fire Apparatus",
      description: "11 Access Road  Albany NY 12205 (518) 250-4161 premierfireapp.com"
    },
    "284": {
      lat: "42.5979551",
      lng: "-76.1711159",
      name: "Priority Fire Apparatus & Service Center",
      description: "115 Port Watson St. Bldg 1  Cortland NY 13045 (607) 753-1080 priorityfireusa.com"
    },
    "285": {
      lat: "42.6059563",
      lng: "-73.1219676",
      name: "Procom Services",
      description: "26 Overlook Terrace  Adams MA 1220 (413) 743-8100 pcsradios.com"
    },
    "286": {
      lat: "44.5332882",
      lng: "-70.51854",
      name: "Professional Vehicle Corp",
      description: "12 Industrial Park Rd  Rumford ME 4276 207-364-2400 provc.net"
    },
    "287": {
      lat: "38.5126456",
      lng: "-90.4429881",
      name: "Public Safety Upfitters",
      description: "1724 W Park Center Dr Suite B Fenton MO 63026 (636) 326-8090 psustl.com"
    },
    "288": {
      lat: "35.3401728",
      lng: "-82.4299707",
      name: "Quality Auto Repair",
      description: "693 Sugarloaf Road  Hendersonville NC 28792 828-692-7969 "
    },
    "289": {
      lat: "41.0467635",
      lng: "-74.0229173",
      name: "Quality Emergency Vehicles LLC",
      description: "  Montvale NJ 7645 (201) 730-2333 facebook.comQualityEV"
    },
    "290": {
      lat: "28.8602435",
      lng: "-81.1777163",
      name: "R5Rescues",
      description: "600 Lake Butler Ave  Osteen FL 32764 (321) 265-9626 r5rescues.com"
    },
    "291": {
      lat: "41.9911414",
      lng: "-76.420885",
      name: "Rapid Fire LLC",
      description: "1773 Snow Rd.  Sayre PA 18840 (570) 423-2605 "
    },
    "292": {
      lat: "40.4406811",
      lng: "-105.0194047",
      name: "Recreational Electrical LLC",
      description: "3950 Medford Drive  Loveland CO 80538 (970) 292-8526 recreationalelectrical.com"
    },
    "293": {
      lat: "35.4576124",
      lng: "-84.6157828",
      name: "Redline Emergency Vehicle Outfitter",
      description: "805 Congress Parkway South  Athens TN 37303 (423) 435-4210 redlineevo.com"
    },
    "294": {
      lat: "34.044538",
      lng: "-117.6270366",
      name: "Redsky Emergency Vehicles",
      description: "1240 E. Locust Street Suite 203 Ontario CA 91671 (866) 500-5948 redskyemergencyvehicles.com"
    },
    "295": {
      lat: "33.6949985",
      lng: "-112.0909856",
      name: "Redsky Emergency Vehicles - Arizona/Nevada",
      description: "23005 North 15th Avenue Suite 207 Phoenix AZ 85027 (866) 522-8311 redskyemergencyvehicles.com"
    },
    "296": {
      lat: "38.7978509",
      lng: "-77.6151782",
      name: "RedStorm Fire & Rescue Apparatus",
      description: "7386 Gallerher Road  Gainesville VA 20155 (866) 805-5111 redstormfire.com"
    },
    "297": {
      lat: "43.3182944",
      lng: "-88.2650216",
      name: "Reliant Fire Apparatus, Inc.",
      description: "880 Enterprise Drive  Slinger WI 53086 (262) 297-5020 reliantfire.com"
    },
    "298": {
      lat: "29.3150767",
      lng: "-98.7644882",
      name: "Rescue Ops",
      description: "13631 Sherwood Rd.  Atascosa TX 78002 (210) 326-1166 rescue-ops.com"
    },
    "299": {
      lat: "35.5275435",
      lng: "-79.6127748",
      name: "Riverside Repair Services LLC",
      description: "8421 Riverside Road  Seagrove NC 27341 (743) 239-7586 "
    },
    "300": {
      lat: "42.8463646",
      lng: "-106.3297072",
      name: "Rocky Mountain Communication Systems",
      description: "414 South Elm Street  Casper WY 82601 307-333-7859 rkycom.com"
    },
    "301": {
      lat: "40.7050997",
      lng: "-111.8980328",
      name: "Rocky Mountain Emergency Group",
      description: "3038 S Specialty Cir  South Salt Lake UT 84115 801-513-0074 rmevgroup.com"
    },
    "302": {
      lat: "40.7399237",
      lng: "-75.298624",
      name: "S. YAHRAES EMERGENCY VEHICLES",
      description: "314B Industrial Drive  Nazareth PA 18064 610-849-6016 facebook.comSYahraesEVS"
    },
    "303": {
      lat: "33.1859969",
      lng: "-85.3089955",
      name: "Safe Industries",
      description: "2202 County Road 91  Roanoke AL 36274 (334) 885-6228 safeindustries.com"
    },
    "304": {
      lat: "32.6013262",
      lng: "-96.6635614",
      name: "Safe Industries",
      description: "1327 E. Belt Line Rd.  Wilmer TX 75172 (833) 777-3473 safeindustries.com"
    },
    "305": {
      lat: "29.3955128",
      lng: "-98.3684127",
      name: "Safe Industries",
      description: "6223 Rigsby Ave.  San Antonio TX 78222 (833) 777-3473 safeindustries.com"
    },
    "306": {
      lat: "29.9310047",
      lng: "-95.3202984",
      name: "Safe Industries",
      description: "4553 Aldine Bender  Houston TX 77032 (833) 777-3473 safeindustries.com"
    },
    "307": {
      lat: "36.0004674",
      lng: "-84.0302698",
      name: "Safe Industries",
      description: "3150 NW Park Dr.  Knoxville TN 37921 (865) 938-8566 safeindustries.com"
    },
    "308": {
      lat: "36.1545275",
      lng: "-86.7352011",
      name: "Safe Industries",
      description: "1122 Lebanon Pike  Nashville TN 37210 (615) 625-0181 safeindustries.com"
    },
    "309": {
      lat: "32.8158602",
      lng: "-116.971538",
      name: "San Diego Friction Products",
      description: "1532 North Johnson Ave.  El Cajon CA 92020 619-270-7160 sandiegofriction.com"
    },
    "310": {
      lat: "41.8217416",
      lng: "-90.5400001",
      name: "Sandry Fire Supply",
      description: "618 6th Street  DeWitt IA 52742 (563) 659-2357 sandryfire.com"
    },
    "311": {
      lat: "39.1139978",
      lng: "-84.8728877",
      name: "SEI Safety Upfitters",
      description: "253 Charles A Liddle Dr. Unit 2 Lawrenceburg IN 47025 (815) 515-5023 seisafetyupfitters.com"
    },
    "312": {
      lat: "38.410821",
      lng: "-90.378707",
      name: "Sentinel Emergency Solutions",
      description: "23 Grandview Park  Arnold MO 63010 800-851-1928 www.sentineles.com"
    },
    "313": {
      lat: "38.4216404",
      lng: "-89.9136701",
      name: "Sentinel Emergency Solutions",
      description: "502 S. Richland St  Freeburg IL 62243 800-851-1928 www.sentineles.com"
    },
    "314": {
      lat: "31.911167",
      lng: "-98.58419",
      name: "SERVS",
      description: "309 FM 3381 Comanche TX 76442 866-356-2236 servsllc.com"
    },
    "315": {
      lat: "40.6190314",
      lng: "-111.9093516",
      name: "Siddons Martin Emergency Group",
      description: "7285 S 700 W St  Midvale UT 84047 801-566-2437 siddons-martin.com"
    },
    "316": {
      lat: "36.0059438",
      lng: "-83.9161935",
      name: "Siddons Martin Emergency Group",
      description: "2812 Deere Drive  Knoxville TN 37917 (865) 269-3841 siddons-martin.com"
    },
    "317": {
      lat: "35.1251523",
      lng: "-106.6371895",
      name: "Siddons-Martin",
      description: "4214 2nd St NW  Albuquerque NM 87107 505-344-9041 siddons-martin.com"
    },
    "318": {
      lat: "29.7590944",
      lng: "-95.949971",
      name: "SIddons-Martin",
      description: "2261 FM 359 S  Brookshire TX 77423 281-934-2200 siddons-martin.com"
    },
    "319": {
      lat: "32.5603531",
      lng: "-96.9612617",
      name: "Siddons-Martin",
      description: "1419 High Meadows Ct Cedar Hill  Cedar Hill TX 75104 972-576-1200 siddons-martin.com"
    },
    "320": {
      lat: "27.7141954",
      lng: "-97.4440089",
      name: "Siddons-Martin",
      description: "2225 Saratoga  Corpus Christi TX 78417 361-249-9355 siddons-martin.com"
    },
    "321": {
      lat: "33.1945911",
      lng: "-97.1811947",
      name: "Siddons-Martin",
      description: "3500 Shelby Lane  Denton TX 76207 940-382-9600 siddons-martin.com"
    },
    "322": {
      lat: "29.8964089",
      lng: "-90.0826342",
      name: "Siddons-Martin",
      description: "3200 Westbank Expy, Ste A  Harvey LA 70058 504-340-6700 siddons-martin.com"
    },
    "323": {
      lat: "29.9267454",
      lng: "-95.3454668",
      name: "Siddons-Martin",
      description: "14233 Interdrive  West Houston TX 77032 281-442-6808 siddons-martin.com"
    },
    "324": {
      lat: "29.4591742",
      lng: "-98.3830636",
      name: "Siddons-Martin",
      description: "5511 Binz-Englemann Rd.  Kirby TX 78219 210-661-3913 siddons-martin.com"
    },
    "325": {
      lat: "29.378215",
      lng: "-95.0044346",
      name: "Siddons-Martin",
      description: "4903 FM 1765  La Marque TX 77568 409-655-3005 siddons-martin.com"
    },
    "326": {
      lat: "30.344204",
      lng: "-97.5151214",
      name: "Siddons-Martin",
      description: "12717 Beltex Dr.  Manor TX 78653 512-272-8484 siddons-martin.com"
    },
    "327": {
      lat: "31.8667003",
      lng: "-102.3887691",
      name: "Siddons-Martin",
      description: "2725 Golder Avenue Odessa, TX 79764-7317  Odessa TX 79764-7317 432-231-4570 siddons-martin.com"
    },
    "328": {
      lat: "26.224298",
      lng: "-98.180384",
      name: "Siddons-Martin",
      description: "104 W Utility Dr  Pharr TX 77577 956-588-2735 siddons-martin.com"
    },
    "329": {
      lat: "29.9272046",
      lng: "-94.0322385",
      name: "Siddons-Martin",
      description: "9645 Jade Avenue  Port Arthur TX 77640 409-736-9077 siddons-martin.com"
    },
    "330": {
      lat: "39.5557944",
      lng: "-119.4989143",
      name: "Siddons-Martin Reno Service Center",
      description: "3033 Waltham Way  Sparks NV 89434 (866) 792-0895 siddons-martin.comreno-service-center"
    },
    "331": {
      lat: "42.4443431",
      lng: "-91.0091783",
      name: "Simon Fire Equipment and Repair",
      description: "207 3rd Street NW  Farley IA 52046 800-628-8443 simonfire.com"
    },
    "332": {
      lat: "40.1993068",
      lng: "-74.8848416",
      name: "SIV Ambulances",
      description: "2400 Big Oak Road  Langhorne PA 19047 (215) 965-1101 sivambulances.com"
    },
    "333": {
      lat: "41.7696641",
      lng: "-74.9045037",
      name: "Skinner's Service Center",
      description: "100 Briscoe Road  Jeffersonville NY 12748 (845) 798-7394 "
    },
    "334": {
      lat: "30.1140669",
      lng: "-95.4224751",
      name: "SMJ Equipment, LLC",
      description: "1409 Spring Creek Dr.  Spring TX 77386 (832) 713-7651 smjequipment.com"
    },
    "335": {
      lat: "34.0368417",
      lng: "-117.6158878",
      name: "South Coast Fire",
      description: "2020 South Baker Ave  Ontario CA 91761 909-673-9900 southcoastfire.net"
    },
    "336": {
      lat: "33.1642626",
      lng: "-117.2019715",
      name: "South Coast Fire Equipment",
      description: "2490 South Santa Fe Ave  Vista CA 92084 (909) 673-9900 southcoastfire.net"
    },
    "337": {
      lat: "35.5921032",
      lng: "-120.6936771",
      name: "South Coast Fire Equipment",
      description: "1650 Ramada Drive Suite 160 Paso Robles CA 93466 (909) 673-9900 southcoastfire.net"
    },
    "338": {
      lat: "33.8818698",
      lng: "-117.6275779",
      name: "South Coast Fire Equipment",
      description: "3150 Palisades Dr.  Corona CA 92878 (909) 673-9900 southcoastfire.netindex.php"
    },
    "339": {
      lat: "26.6431957",
      lng: "-81.8185507",
      name: "SOUTH FLORIDA EMERGENCY VEHICLES",
      description: "4655 Cummins Ct  Fort Myers FL 33905 (239) 267-5300 sflev.com"
    },
    "340": {
      lat: "36.9519468",
      lng: "-84.065386",
      name: "SOUTHEAST APPARATUS LLC",
      description: "326 Lynn Camp School Rd  Corbin KY 40701 (888) 996-6277 southeastapparatus.comindex.html"
    },
    "341": {
      lat: "36.285482",
      lng: "-78.391155",
      name: "Southeastern Specialty Vehicles",
      description: "911 Martin Creek Road  Henderson NC 27537 (866) 640-2028 ssvsales.com"
    },
    "342": {
      lat: "29.375199",
      lng: "-82.439498",
      name: "Southeastern Upfitters",
      description: "3080 NE 200 Avenue  Williston FL 32696 (352) 528-2264 southeasternupfitters.com"
    },
    "343": {
      lat: "34.4017589",
      lng: "-86.4491538",
      name: "Southern Emergency Consultants",
      description: "15410 US Hwy 231  Union Grove AL 35175 (706) 594-2228 secambulance.com"
    },
    "344": {
      lat: "35.515892",
      lng: "-82.9691109",
      name: "Sparksmith",
      description: "60 Communications Dr  Waynesville NC 28786 (828) 508-0917 sparksmith.com"
    },
    "345": {
      lat: "35.6065445",
      lng: "-78.5550438",
      name: "Spartan Fire & Emergency",
      description: "431 Cleveland Crossing Drive Suite 209 Garner NC 27529 866-582-2376 spartanfire.com"
    },
    "346": {
      lat: "42.0158477",
      lng: "-71.3483864",
      name: "Specialty Vehicle Inc.",
      description: "18 Commerce Blvd  Plainville MA 2762 508-699-0616 svine.com"
    },
    "347": {
      lat: "39.0296298",
      lng: "-96.8191819",
      name: "Specialty Vehicle Source",
      description: "705 E. 8th St.  Junction City KS 66441 (785)-477-8370 svsks.com"
    },
    "348": {
      lat: "40.1100104",
      lng: "-79.5764211",
      name: "SPECLIN EMERGENCY VEHICLE SALES & SERVICE",
      description: "409 Porter Ave  Scottdale PA 15683 (724) 887-6822 speclin.net"
    },
    "349": {
      lat: "32.5239959",
      lng: "-86.6839506",
      name: "Station 2 Lights and Sirens LLC",
      description: "704 County Road 40 W  Prattville AL 36067 (334) 310-8322 "
    },
    "350": {
      lat: "33.1576031",
      lng: "-99.7337014",
      name: "Steele Fire Apparatus, LLC",
      description: "247 US HWY 380 West  Haskell TX 79521 (800) 687-7639 steelefire.com"
    },
    "351": {
      lat: "42.8144822",
      lng: "-84.7572197",
      name: "Strobes and Sirens LLC",
      description: "11950 West Clark Road  Eagle MI 48822 15176262677 strobesandsirens.com"
    },
    "352": {
      lat: "32.2496942",
      lng: "-110.9711194",
      name: "Sunwest Supply, Inc.",
      description: "15 E. Sahuaro Street  Tuscon AZ 85705 (520) 882-5717 "
    },
    "353": {
      lat: "46.4898431",
      lng: "-84.3506684",
      name: "Superior Upfitting LLC",
      description: "909 John Street  Sault Ste. Marie MI 49783 (269) 760-7432 superiorupfitting.com"
    },
    "354": {
      lat: "40.5471231",
      lng: "-76.814227",
      name: "Swab Wagon Co.",
      description: "44 S. Callowhill St.  Elizabethville PA 17023 (800) 834-7922 swabwagon.com"
    },
    "355": {
      lat: "40.1272916",
      lng: "-76.4578242",
      name: "Swatara Warning Lights",
      description: "2459 Mount Joy Rd  Manheim PA 17545 (717) 708-1422 swataralights.com"
    },
    "356": {
      lat: "34.0269954",
      lng: "-83.6856584",
      name: "Tactical Fire LLC",
      description: "517 Lamar Giles Rd.  Winder GA 30680 (404) 408-7717 tacticalfirevehicles.com"
    },
    "357": {
      lat: "32.712351",
      lng: "-86.318306",
      name: "Tactical Fire LLC",
      description: "  Titus AL 36080 (404) 408-7717 tacticalfirevehicles.com"
    },
    "358": {
      lat: "31.8087678",
      lng: "-85.969951",
      name: "Tactical Fire LLC",
      description: "  Troy AL 36081 (404) 408-7717 tacticalfirevehicles.com"
    },
    "359": {
      lat: "30.1973686",
      lng: "-85.4994192",
      name: "Tactical Fire LLC",
      description: "  Panama City FL 32404 (404) 408-7717 tacticalfirevehicles.com"
    },
    "360": {
      lat: "36.3412594",
      lng: "-82.3234843",
      name: "Tactical Fire LLC",
      description: "  Johnson City TN 37601 (404) 408-7717 tacticalfirevehicles.com"
    },
    "361": {
      lat: "40.9623892",
      lng: "-85.3732923",
      name: "Taylor'd Equipment Sales & Install",
      description: "PO Box 495  Roanoke IN 46783 260-615-4493 taylordequipment.com"
    },
    "362": {
      lat: "43.1702779",
      lng: "-77.6141871",
      name: "TELE-LITE",
      description: "80 LOWELL STREET  ROCHESTER NY 14603 800-538-0022 tele-lite.com"
    },
    "363": {
      lat: "31.6983322",
      lng: "-95.7232567",
      name: "Texas Fire Apparatus",
      description: "8100 US Route 79  Palestine TX 75801 (877) 347-3875 texasfireapparatus.com"
    },
    "364": {
      lat: "29.4442657",
      lng: "-95.0150449",
      name: "TEXAS FIRST RESPONSE SERVICES",
      description: "7727 Wetzel Rd  Dickinson TX 77539 (409) 504-2303 tx1rs.com"
    },
    "365": {
      lat: "37.5640051",
      lng: "-77.4596895",
      name: "The Fire Store",
      description: "1614 Ownby Ln  Richmond VA 23220 (804) 267-3424 thefirestore.com"
    },
    "366": {
      lat: "39.8447301",
      lng: "-79.6180566",
      name: "The Fire Store",
      description: "2961 National Pike  Chalk Hill PA 15421 (800) 437-1801 thefirestore.com"
    },
    "367": {
      lat: "39.5958193",
      lng: "-77.8059576",
      name: "The Fire Store",
      description: "10228 Governor Lane Blvd. Suite 3012 Williamsport MD 21795 (888) 560-3473 thefirestore.com"
    },
    "368": {
      lat: "39.9841629",
      lng: "-75.8819884",
      name: "The Fire Store",
      description: "104 Independence Way  Coatesville PA 19320 800-852-6088 thefirestore.com"
    },
    "369": {
      lat: "39.8511639",
      lng: "-84.9082734",
      name: "THL Fire Equipment",
      description: "1700 NW 5th St.  Richmond IN 47374 (765) 979-0319 thlfireequipment.com"
    },
    "370": {
      lat: "30.3506481",
      lng: "-95.5825283",
      name: "Trinity Apparatus",
      description: "14547 Lake Business Dr 303 Conroe TX 77304 (936) 494-2552 trinityapparatus.com"
    },
    "371": {
      lat: "35.6312619",
      lng: "-87.0382911",
      name: "Tristar Fire",
      description: "406 Santa Fe Pike  Columbia TN 38401 615-668-3401 tristarfiretn.com"
    },
    "372": {
      lat: "43.5834391",
      lng: "-116.2731619",
      name: "TruckPro",
      description: "2138 Century Way  Boise ID 83709 1-844-757-1423 truckpro.com"
    },
    "373": {
      lat: "45.4954374",
      lng: "-122.9171779",
      name: "True North Emergency Equipment",
      description: "3150 SE Century Blvd  Hillsboro OR 97123 503-848-3276 truenorthemergency.com"
    },
    "374": {
      lat: "30.0518768",
      lng: "-95.4329674",
      name: "U.S Fire Truck Parts",
      description: "139 Cypresswood STE 84 Spring TX 77388 (832) 381-7791 us-firetruckparts.com"
    },
    "375": {
      lat: "30.23283",
      lng: "-95.5663525",
      name: "Ultimate Lighting Solutions",
      description: "817 Weisinger Drive  Magnolia TX 77354 (281) 433-0318 ultimatelightingsolutions.net"
    },
    "376": {
      lat: "40.8163923",
      lng: "-73.2380172",
      name: "Ultra Bright Lightz",
      description: "40 Oser Ave Suite 14 Hauppauge NY 11788 (888) 562-5125 ultrabrightlightz.com"
    },
    "377": {
      lat: "41.4226339",
      lng: "-78.7100948",
      name: "Utilitac Equipment & Upfitting",
      description: "6584 Ridgway St. Mary's Rd.  Ridgway PA 15853 (844) 288-7348 utilitac.com"
    },
    "378": {
      lat: "43.0316027",
      lng: "-76.0667482",
      name: "Vander Molen Fire Apparatus Sales & Service",
      description: "224 Wellington Road  Dewitt NY 13214 (518) 926-0451 vm-fire.com"
    },
    "379": {
      lat: "39.7925606",
      lng: "-74.9234604",
      name: "VCI Emergency Vehicle Specialists",
      description: "43 Jefferson Avenue  Berlin NJ 8009 (800) 394-2162 vciambulances.com"
    },
    "380": {
      lat: "40.5686889",
      lng: "-74.4253544",
      name: "VCI Emergency Vehicle Specialists",
      description: "3560 Kennedy Rd  South Plainfield NJ 7080 (800) 394-2162 vciambulances.com"
    },
    "381": {
      lat: "40.7727467",
      lng: "-73.0841539",
      name: "VCI Emergency Vehicle Specialists",
      description: "920 Lincoln Ave.  Holbrook NY 11741 (800) 394-2162 vciambulances.com"
    },
    "382": {
      lat: "41.3211095",
      lng: "-75.728561",
      name: "VCI Emergency Vehicle Specialists",
      description: "20 Freeport Road  Pittston PA 18640 (800) 394-2162 vciambulances.com"
    },
    "383": {
      lat: "35.3459099",
      lng: "-80.8466866",
      name: "Vector Fleet Management",
      description: "9300 Harris Corners Parkway  Charlotte NC 28269 704-921-0148 vectorfleet.com"
    },
    "384": {
      lat: "33.4574197",
      lng: "-112.2688357",
      name: "Velocity Fire Equipment & Sales",
      description: "9899 W. Roosevelt Street  Telleson AZ 85353 (866) 570-1474 vtcfire.com"
    },
    "385": {
      lat: "37.0028813",
      lng: "-80.2334819",
      name: "Vest Sales and Service, Inc.",
      description: "1157 Stonewall Rd. NE  Check VA 24072 1-866-225-8144 fireandrescuesales.com"
    },
    "386": {
      lat: "42.1638757",
      lng: "-76.8838077",
      name: "Ward Apparatus",
      description: "1250 Schweizer Rd.  Horseheads NY 14845 (607) 733-5511 wardapparatus.com"
    },
    "387": {
      lat: "40.259121",
      lng: "-79.571626",
      name: "Webb's Service Center",
      description: "5075 Old U.S. 119  Greensburg PA 15601 724-837-9774 www.webbs-service.com"
    },
    "388": {
      lat: "38.8564832",
      lng: "-97.6083296",
      name: "WEIS FIRE & SAFETY EQUIPMENT CO INC",
      description: "111 E Pacific Ave  Salina KS 67402 (785) 825-9527 weisfiresafety.com"
    },
    "389": {
      lat: "38.5519099",
      lng: "-90.3353516",
      name: "WF GEAR",
      description: "55 Grasso Plaza  St. Louis MO 63123 (314) 270-9416 wfgear.com"
    },
    "390": {
      lat: "32.5129114",
      lng: "-97.1738303",
      name: "Wildfire Truck & Equipment Sales",
      description: "5313 Big Six Street  Alvarado TX 76009 (817) 783-3833 brushtruck.com"
    },
    "391": {
      lat: "33.2922103",
      lng: "-85.8964527",
      name: "Williams Fire Apparatus",
      description: "778 Idaho Rd  Ashland AL 36251 800-239-7900 williamsfireinc.com"
    },
    "392": {
      lat: "39.983434",
      lng: "-75.879747",
      name: "Witmer Public Safety Group",
      description: "101 Independence Way  Coatesville PA 19320 610-857-8070 wpsginc.com"
    }
  },
  labels: {
    NH: {
      parent_id: "NH",
      x: "932",
      y: "183",
      pill: "yes",
      width: 45,
      display: "all"
    },
    VT: {
      parent_id: "VT",
      x: "883",
      y: "243",
      pill: "yes",
      width: 45,
      display: "all"
    },
    RI: {
      parent_id: "RI",
      x: "932",
      y: "273",
      pill: "yes",
      width: 45,
      display: "all"
    },
    NJ: {
      parent_id: "NJ",
      x: "883",
      y: "273",
      pill: "yes",
      width: 45,
      display: "all"
    },
    DE: {
      parent_id: "DE",
      x: "883",
      y: "303",
      pill: "yes",
      width: 45,
      display: "all"
    },
    MD: {
      parent_id: "MD",
      x: "932",
      y: "303",
      pill: "yes",
      width: 45,
      display: "all"
    },
    DC: {
      parent_id: "DC",
      x: "884",
      y: "332",
      pill: "yes",
      width: 45,
      display: "all"
    },
    MA: {
      parent_id: "MA",
      x: "932",
      y: "213",
      pill: "yes",
      width: 45,
      display: "all"
    },
    CT: {
      parent_id: "CT",
      x: "932",
      y: "243",
      pill: "yes",
      width: 45,
      display: "all"
    },
    HI: {
      parent_id: "HI",
      x: 305,
      y: 565,
      pill: "yes"
    },
    AK: {
      parent_id: "AK",
      x: "113",
      y: "495"
    },
    FL: {
      parent_id: "FL",
      x: "773",
      y: "510"
    },
    ME: {
      parent_id: "ME",
      x: "893",
      y: "85"
    },
    NY: {
      parent_id: "NY",
      x: "815",
      y: "158"
    },
    PA: {
      parent_id: "PA",
      x: "786",
      y: "210"
    },
    VA: {
      parent_id: "VA",
      x: "790",
      y: "282"
    },
    WV: {
      parent_id: "WV",
      x: "744",
      y: "270"
    },
    OH: {
      parent_id: "OH",
      x: "700",
      y: "240"
    },
    IN: {
      parent_id: "IN",
      x: "650",
      y: "250"
    },
    IL: {
      parent_id: "IL",
      x: "600",
      y: "250"
    },
    WI: {
      parent_id: "WI",
      x: "575",
      y: "155"
    },
    NC: {
      parent_id: "NC",
      x: "784",
      y: "326"
    },
    TN: {
      parent_id: "TN",
      x: "655",
      y: "340"
    },
    AR: {
      parent_id: "AR",
      x: "548",
      y: "368"
    },
    MO: {
      parent_id: "MO",
      x: "548",
      y: "293"
    },
    GA: {
      parent_id: "GA",
      x: "718",
      y: "405"
    },
    SC: {
      parent_id: "SC",
      x: "760",
      y: "371"
    },
    KY: {
      parent_id: "KY",
      x: "680",
      y: "300"
    },
    AL: {
      parent_id: "AL",
      x: "655",
      y: "405"
    },
    LA: {
      parent_id: "LA",
      x: "550",
      y: "435"
    },
    MS: {
      parent_id: "MS",
      x: "600",
      y: "405"
    },
    IA: {
      parent_id: "IA",
      x: "525",
      y: "210"
    },
    MN: {
      parent_id: "MN",
      x: "506",
      y: "124"
    },
    OK: {
      parent_id: "OK",
      x: "460",
      y: "360"
    },
    TX: {
      parent_id: "TX",
      x: "425",
      y: "435"
    },
    NM: {
      parent_id: "NM",
      x: "305",
      y: "365"
    },
    KS: {
      parent_id: "KS",
      x: "445",
      y: "290"
    },
    NE: {
      parent_id: "NE",
      x: "420",
      y: "225"
    },
    SD: {
      parent_id: "SD",
      x: "413",
      y: "160"
    },
    ND: {
      parent_id: "ND",
      x: "416",
      y: "96"
    },
    WY: {
      parent_id: "WY",
      x: "300",
      y: "180"
    },
    MT: {
      parent_id: "MT",
      x: "280",
      y: "95"
    },
    CO: {
      parent_id: "CO",
      x: "320",
      y: "275"
    },
    UT: {
      parent_id: "UT",
      x: "223",
      y: "260"
    },
    AZ: {
      parent_id: "AZ",
      x: "205",
      y: "360"
    },
    NV: {
      parent_id: "NV",
      x: "140",
      y: "235"
    },
    OR: {
      parent_id: "OR",
      x: "100",
      y: "120"
    },
    WA: {
      parent_id: "WA",
      x: "130",
      y: "55"
    },
    ID: {
      parent_id: "ID",
      x: "200",
      y: "150"
    },
    CA: {
      parent_id: "CA",
      x: "79",
      y: "285"
    },
    MI: {
      parent_id: "MI",
      x: "663",
      y: "185"
    },
    PR: {
      parent_id: "PR",
      x: "620",
      y: "545"
    },
    GU: {
      parent_id: "GU",
      x: "550",
      y: "540"
    },
    VI: {
      parent_id: "VI",
      x: "680",
      y: "519"
    },
    MP: {
      parent_id: "MP",
      x: "570",
      y: "575"
    },
    AS: {
      parent_id: "AS",
      x: "665",
      y: "580"
    }
  },
  legend: {
    entries: []
  },
  regions: {}
};